// extracted by mini-css-extract-plugin
export default {"body":"Eh89q","icon":"yKUuO","content":"IYv_w"};